import PropTypes from 'prop-types'

import { Typography, Box } from '@mui/material'

import Autocomplete from '../../../../ui/components/autocomplete'
import { getFieldProps } from '../../../../common/formProps'
import useTranslations from '../../../../i18n/useTranslations'
import { getServiceTypeOptions } from '../../../../context/business'

const ServiceType = ({
  centers,
  values,
  fieldErrors,
  touched,
  handleChange,
}) => {
  const t = useTranslations()

  const options = getServiceTypeOptions(centers, values.clientCenterCode)

  return (
    <Autocomplete
      sx={{ width: '100%' }}
      options={options}
      noOptionsText={t('message:no-results')}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      name="serviceType"
      inputProps={{
        placeholder: t('placeholder:service-type'),
        name: 'serviceType',
        label: (
          <Typography variant="h4bold">{t('noun:service-type')}</Typography>
        ),
        type: 'text',
        ...getFieldProps('serviceType', values, fieldErrors, touched, t),
        className: 'full-width ',
      }}
      onChange={(_, value) => {
        handleChange({ target: { name: 'serviceType', value } })
      }}
      value={values.serviceType}
      autoHighlight
      id="serviceType"
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.code}>
          {option.label}
        </Box>
      )}
    />
  )
}
ServiceType.propTypes = {
  centers: Autocomplete.propTypes.options,
  values: PropTypes.shape({
    clientCenterCode: PropTypes.string.isRequired,
    serviceType: PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  }),
  fieldErrors: PropTypes.shape({
    clientCenterCode: PropTypes.string.isRequired,
    serviceType: PropTypes.string.isRequired,
  }),
  touched: PropTypes.shape({
    clientCenterCode: PropTypes.string,
    serviceType: PropTypes.string,
  }),
  handleChange: PropTypes.func.isRequired,
}

export default ServiceType
